// Tarjeta de un partido abierto en el listado público de canchas ("Partidos abiertos").
// Muestra club + zona, deporte, día/hora, cancha, lugares (avatares y libres), tipo, precio por
// jugador y cierre. Toda la tarjeta lleva al detalle `/partidos/:id` (pantalla de T9); no hace
// llamadas ni conoce filtros: recibe el resumen público que devuelve GET /api/app/open-matches.
import React from "react";
import { SPORT_LABELS } from "../../../constants/courtDomain";
import RIcon from "../../reservas/components/ReservasIcons";
import { FALLBACK_IMAGE } from "../../reservas/components/ReservaShared";
import {
	MATCH_KIND_LABELS,
	formatCloseAt,
	formatMatchDay,
	formatPricePerPlayer,
	missingLabel,
	playerInitials,
} from "../openMatchesModel";
import "./OpenMatchCard.css";

const OpenMatchCard = ({ match, onOpen }) => {
	const club = match.club || {};
	const players = Array.isArray(match.players) ? match.players : [];
	// Lugares libres = capacidad - jugadores activos (el back ya manda solo los activos).
	const emptySlots = Math.max(0, (Number(match.capacity) || 0) - players.length);
	const zone = [club.cityName, club.stateName].filter(Boolean).join(", ");
	const open = () => onOpen(match);

	return (
		<div
			className="bar-card open-match-card"
			data-testid="open-match-card"
			role="link"
			tabIndex={0}
			onClick={open}
			onKeyDown={(e) => {
				if (e.key === "Enter") open();
			}}
		>
			<div className="open-match-head">
				<img
					className="open-match-club-img"
					src={club.image || FALLBACK_IMAGE}
					alt=""
					onError={(e) => {
						e.currentTarget.src = FALLBACK_IMAGE;
					}}
				/>
				<div className="open-match-club">
					<div className="bar-name">{club.name || match.clubName}</div>
					{zone && (
						<div className="bar-loc">
							<RIcon name="pin" width={14} height={14} />
							{zone}
						</div>
					)}
				</div>
			</div>

			<div className="bar-body">
				<div className="open-match-when">
					{`${formatMatchDay(match.date)} · ${match.slotStart} - ${match.slotEnd}`}
				</div>
				<div className="bar-tags">
					<span className="bar-tag">{SPORT_LABELS[match.sport] || match.sport}</span>
					<span className="bar-tag">{MATCH_KIND_LABELS[match.kind] || match.kind}</span>
				</div>
				{match.courtName && <div className="open-match-court">{match.courtName}</div>}

				<div className="open-match-slots">
					{players.map((p) => (
						<span
							key={p._id}
							className="open-match-avatar"
							data-testid="open-match-slot-filled"
							title={p.name}
						>
							{playerInitials(p.name)}
						</span>
					))}
					{Array.from({ length: emptySlots }).map((_, i) => (
						<span
							key={`empty-${i}`}
							className="open-match-avatar is-empty"
							data-testid="open-match-slot-empty"
						>
							+
						</span>
					))}
					<span className="open-match-missing">{missingLabel(match.missing)}</span>
				</div>

				<div className="open-match-foot">
					<div className="open-match-price">
						<b>{formatPricePerPlayer(match.pricePerPlayer)}</b>{" "}
						<span>por jugador</span>
					</div>
					{match.closeAt && (
						<div className="open-match-close">{formatCloseAt(match.closeAt)}</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default OpenMatchCard;
